/**
 * TrendModa - Favoriler (LocalStorage + Shopify Product API)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tm_wishlist';
  var IS_LOGGED_IN = window.customer_logged_in || false;

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // Kalp ikonlarını ve header sayacını güncelle (sayfa yeniden render etmez)
  function syncHearts() {
    var list = getWishlist();
    var count = list.length;

    document.querySelectorAll('.ty-header__wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var handle = btn.dataset.wishlistHandle;
      var isActive = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.fill = isActive ? '#f27a1a' : 'none';
        svg.style.stroke = isActive ? '#f27a1a' : 'currentColor';
      }
    });
  }

  // Favoriler sayfasını render et — syncHearts()'ı çağırmaz (sonsuz döngü engeli)
  async function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var countDisplay = document.getElementById('wishlist-count-display');
    var handles = getWishlist();

    if (countDisplay) countDisplay.textContent = handles.length;

    if (handles.length === 0) {
      if (grid) grid.style.display = 'none';
      if (empty) empty.style.display = 'block';
      return;
    }

    if (!grid) return;
    grid.style.display = 'grid';
    if (empty) empty.style.display = 'none';

    // Tüm ürünleri paralel fetch et (sıralı bekleme yerine)
    var cards = await Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    );

    var html = cards
      .filter(function (p) { return p !== null; })
      .map(renderProductCard)
      .join('');

    // Clear skeleton cards before inserting real content
    grid.querySelectorAll('.wishlist__skeleton-card').forEach(function (el) { el.remove(); });
    grid.innerHTML = html;

    // Trigger lazy loading for newly inserted images
    if (window.tmLazy) window.tmLazy.initImageLazyLoad();

    // Render sonrası kalp ikonlarını güncelle (renderWishlistPage çağırmadan!)
    syncHearts();
  }

  function renderProductCard(product) {
    var priceNum = product.price ? product.price / 100 : 0;
    var price = priceNum.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
    var imgSrc = product.featured_image
      ? escapeHtml(product.featured_image + '&width=540')
      : '';
    var title = escapeHtml(product.title || '');
    var vendor = escapeHtml(product.vendor || '');
    var url = escapeHtml(product.url || '/products/' + product.handle);

    return '<div class="grid__item">' +
      '<div class="ty-card">' +
        '<div class="ty-card__image-wrapper">' +
          '<a href="' + url + '" class="ty-card__image-link">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + title + '" class="ty-card__img" loading="lazy">' : '') +
          '</a>' +
          '<button class="ty-card__heart is-active" data-wishlist-handle="' + escapeHtml(product.handle) + '" aria-pressed="true" aria-label="Favorilerden çıkar">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="#f27a1a" stroke="#f27a1a" stroke-width="2">' +
              '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="ty-card__info">' +
          '<a href="' + url + '" class="ty-card__title-link">' +
            (vendor ? '<span class="ty-card__brand">' + vendor + '</span>' : '') +
            '<span class="ty-card__name">' + title + '</span>' +
          '</a>' +
          '<div class="ty-card__price">' +
            '<span class="ty-card__price-regular">' + price + '</span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function handleFavoriteClick(e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.wishlistHandle;
    var list = getWishlist();
    var idx = list.indexOf(handle);

    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    syncHearts();

    // Favoriler sayfasındaysa listeyi yenile
    var isWishlistPage = window.location.pathname.indexOf('wishlist') !== -1 ||
                         window.location.pathname.indexOf('favori') !== -1;
    if (isWishlistPage) renderWishlistPage();
  }

  function init() {
    syncHearts();

    // Favoriler sayfasındaysa içeriği yükle
    var isWishlistPage = window.location.pathname.indexOf('wishlist') !== -1 ||
                         window.location.pathname.indexOf('favori') !== -1;
    if (isWishlistPage) renderWishlistPage();

    document.addEventListener('click', handleFavoriteClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for manual trigger
  window.tmWishlist = { syncHearts: syncHearts };
})();

